import { Alert } from '@synoptic/ui-kit/alert/alert.js';
import { ClockIcon } from '@synoptic/ui-kit/icons/react/clock.js';
import { space } from '@synoptic/ui-kit/tokens.js';
import { ReactNode } from 'react';
import { useRedesign } from '@/feature-flags/redesign/use-redesign.ts';
import {
  delayedPreviewAlertIconV2,
  delayedPreviewAlertTextV2,
  delayedPreviewAlertV2,
} from './stream-data-v2.css.ts';

export const DelayedPreviewAlert = ({ children }: { children: ReactNode }) => {
  const redesign = useRedesign();

  if (redesign) {
    return (
      <div
        className={delayedPreviewAlertV2}
        data-testid="delayed-preview-alert"
      >
        <ClockIcon
          className={delayedPreviewAlertIconV2}
          width={16}
          height={16}
        />
        <span className={delayedPreviewAlertTextV2}>{children}</span>
      </div>
    );
  }

  return (
    <Alert
      style={{ marginBottom: space.s16 }}
      icon={<ClockIcon />}
      data-testid="delayed-preview-alert"
      color="prominent"
    >
      {children}
    </Alert>
  );
};
